import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TblBtnRowExtend } from '@ascschool/interface/button/table-btn-row-extend';

@Component({
  selector: 'table-btn-row-extend',
  templateUrl: './table-btn-row-extend.component.html',
  styleUrls: ['./table-btn-row-extend.component.scss']
})
export class TableBtnRowExtendComponent implements OnInit {
  @Input() buttonList: TblBtnRowExtend;
  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }
  hanlder(item){
    item.handler(this.data);
  }
}
